import React from 'react';
import { Header } from '../components/Header';
import { Sidebar } from '../components/Sidebar';
import { ArticleContent } from '../components/ArticleContent';
export function AdvertorialPage() {
  return <div className="min-h-screen bg-[#FAFAFA] font-sans text-gray-800" data-id="element-196">
      <Header data-id="element-197" />

      <main className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-12 py-8 md:py-12" data-id="element-198">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16" data-id="element-199">
          <ArticleContent data-id="element-200" />
          <Sidebar data-id="element-201" />
        </div>
      </main>

      <footer className="bg-gray-900 text-gray-400 py-12 mt-12" data-id="element-202">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-sm" data-id="element-203">
          <p className="mb-4" data-id="element-204">
            © 2024 The Daily Chronicle. All rights reserved.
          </p>
          <p className="max-w-2xl mx-auto text-xs opacity-60" data-id="element-205">
            THIS IS AN ADVERTORIAL AND NOT AN ACTUAL NEWS ARTICLE, BLOG, OR
            CONSUMER PROTECTION UPDATE. The story depicted on this site and the
            person depicted in the story are not actual news. Rather, this story
            is based on the results that some people who have used these
            products have achieved.
          </p>
        </div>
      </footer>
    </div>;
}